var merge = require('./lib/merge'),
    countDefinedItems = require('./lib/countDefinedItems'),
    slice = Array.prototype.slice,
    __;


function curry(fn, length, curryArgs) {
  return function() {
    var args = slice.call(arguments),
      concatArgs = curryArgs.concat(args),
      mergedArgs = [];

    if (length <= countDefinedItems(concatArgs)) {
      mergedArgs = merge(args, curryArgs);
      return fn.apply(null, mergedArgs);
    } else {
      if (length >= concatArgs.length) {
        return curry(fn, length, concatArgs);
      } else {
        return curry(fn, length, merge(args, curryArgs));
      }
    }
  };
}

module.exports = function(fn) {
  var args = slice.call(arguments, 1);

  return curry(fn, fn.length, args);
};

module.exports.n = function(fn, length) {
  var args = slice.call(arguments, 2);

  return curry(fn, length, args);
};

module.exports.__ = __;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/chickencurry/index.js
// module id = rYvd
// module chunks = 0